import React, { Component } from "react";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DiscussionEntries from "../discussions/DiscussionEntries";
import { withRouter } from "react-router";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import DisplayUser from "../../components/user/DisplayUser";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import moment from "moment";
import LockIcon from "@material-ui/icons/Lock";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
    },
  },
  secondarySpan: {
    verticalAlign: "middle",
    // marginLeft: "5px"
  },
});
export class ItemExpertQuestion extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    extendedString: "",
    discussion: {},
    discussionEntries: [],
    instance: new Date().getTime().toString(),
  };

  componentDidMount() {
    this.setState({ discussion: this.props.data });
    this.extendedInfo(this.props.extendedSettings);
    this.secondaryInfo(this.props.listSettings);
    this.defaultFullscreenInfo(this.props.fullscreenSettings);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.extendedSettings !== this.props.extendedSettings) {
      this.extendedInfo(this.props.extendedSettings);
    }
    if (prevProps.listSettings !== this.props.listSettings) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }

  render() {
    return (
      <KpsListItem
        preText={this.props.preText}
        isPortlet={this.props.isPortlet}
        onItemClick={
          this.props.discussionPortlet
            ? this.onItemClick
            : () => this.props.onItemClick(this.props.data)
        }
        extendedString={this.state.extendedString}
        provided={this.props.provided}
        menuDialog={this.props.menuDialog}
        fullscreen={this.props.fullscreen}
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings).map((setting, idx) => {
                return <>{this.getSettingInfo(setting)}</>;
              })
            : this.state.defaultFullscreen
        }
      >
        {this.props.preText}
        <ListItemText
          primary={this.primaryInfo()}
          secondary={this.state.secondaryString}
          style={{ overflowWrap: "anywhere" }}
        />
      </KpsListItem>
    );
  }
  getLockedIconAndTooltip = () => {
    return (
      <Tooltip
        title={
          <Typography>
            {this.props.t("discussion_locked", {
              interpolation: {
                escapeValue: false,
              },
              user: this.props.data.lockingUser
                ? this.props.data.lockingUser.firstName +
                  " " +
                  this.props.data.lockingUser.surname +
                  " (" +
                  this.props.data.lockingUser.userLogin +
                  ")"
                : "Unknown",
              date: moment(this.props.data.dateLocked).format(
                "DD/MM/YYYY HH:mm"
              ),
            })}
          </Typography>
        }
        enterDelay={300}
      >
        <LockIcon color="primary" />
      </Tooltip>
    );
  };
  showDiscussionList = () => {
    this.setState({
      viewDiscussion: !this.state.viewDiscussion,
    });
  };

  onItemClick = () => {
    this.props.data.type === "DOCUMENT"
      ? this.props.history.push({
          pathname: `/full/document/${this.props.data.documentId}`,
          state: { discussionId: this.props.data.id },
        })
      : this.props.history.push({
          pathname: `/full/discussion/${this.props.data.discussionId}`,
          state: { discussionId: this.props.data.id },
        });
  };

  primaryInfo() {
    let info = this.props.data.title;
    return info;
  }
  defaultFullscreenInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      for (let i = 0; i < this.props.expertQuestionOptions.length; i++) {
        settings.push({ label: this.props.expertQuestionOptions[i], order: i });
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "settings_discussions_posted_by" && (
          <TableCell>
            <DisplayUser
              userId={this.props.data.postedById}
              user={this.props.data.postedBy}
            />
          </TableCell>
        )}
        {setting.label === "settings_discussions_location" && (
          <TableCell>
            {
              <DisplayLocation
                type={this.props.data.type}
                itemId={this.props.data.itemId}
                topicId={this.props.data.topicId}
                title={this.props.data.targetTitle}
              />
            }
          </TableCell>
        )}
        {setting.label === "settings_discussions_date_created" && (
          <TableCell>
            {!!this.props.data.time
              ? moment(this.props.data.time).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_discussions_number_posts" && (
          <TableCell>{this.props.data.numberOfEntries}</TableCell>
        )}
        {setting.label === "settings_discussions_number_views" && (
          <TableCell>
            {this.props.data.views ? this.props.data.views : 0}
          </TableCell>
        )}
        {setting.label === "settings_discussions_date_last_post" && (
          <TableCell>
            {moment(this.props.data.lastPostDate).format("LLL")}
          </TableCell>
        )}
        {setting.label === "settings_expert_question_status" && (
          <TableCell>
            {this.props.data.locked && this.props.data.expertQuestionStatus !== "RESOLVED"  
              ? this.getLockedIconAndTooltip() 
              : this.props.t("expert_question_status_" + this.props.data.expertQuestionStatus.toLowerCase())}
          </TableCell>
        )}
        {setting.label === "settings_expert_question_visibility" && (
          <TableCell>{this.props.t(this.props.data.expertQuestionVisibility.toLowerCase().replace("public_view_only","public_view"))}</TableCell>
        )}
        {setting.label === "settings_expert_question_urgency" && (
          <TableCell>{this.props.t("expert_question_urgency_" + this.props.data.urgency.toLowerCase())}</TableCell>
        )}
      </>
    );
  };
  getUrgencyIcon = () => {
    if (this.props.data.urgency === "HIGH") {
      return "mdi-chevron-triple-up";
    } else if (this.props.data.urgency === "LOW") {
      return "mdi-chevron-up";
    }
    return "mdi-chevron-double-up";
  };
  returnSettingItem = (settings) => {
    const { classes } = this.props;
    let fontWeight = { fontWeight: this.props.fullscreen ? "bold" : "normal" };
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {this.props.data.urgency && (
          <span className={classes.iconSpan}>
            <Tooltip
              title={
                <Typography>
                  {this.props.t("global_expert_question_urgency")}:{" "}
                  {this.props.data.urgency}
                </Typography>
              }
              aria-label={`${this.props.t("global_expert_question_urgency")}: ${
                this.props.data.urgency
              }`}
            >
              <span
                style={{ fontSize: "1.4em" }}
                className={`mdi ${this.getUrgencyIcon()}`}
              />
            </Tooltip>
          </span>
        )}
        <span className={classes.secondarySpan}>
          {settings === "settings_discussions_posted_by" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_discussions_posted_by")}
              </div>{" "}
              <div>: {this.props.data.postedById}&nbsp;</div>
            </div>
          )}
          {settings === "settings_discussions_location" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_discussions_location")}
              </div>
              <div>: {this.props.data.location}&nbsp;</div>
            </div>
          )}
          {settings === "settings_discussions_date_created" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_discussions_date_created")}{" "}
              </div>
              <div>: {moment(this.props.data.time).format("LLL")}&nbsp;</div>
            </div>
          )}
          {settings === "settings_discussions_number_posts" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_discussions_number_posts")}
              </div>
              <div>: {this.props.data.numberOfEntries}&nbsp;</div>
            </div>
          )}
          {settings === "settings_discussions_number_views" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_discussions_number_views")}
              </div>
              <div>
                : {this.props.data.views ? this.props.data.views : 0}&nbsp;
              </div>
            </div>
          )}
          {settings === "settings_discussions_date_last_post" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_discussions_date_last_post")}
              </div>
              <div>
                : {moment(this.props.data.lastPostDate).format("LLL")}&nbsp;
              </div>
            </div>
          )}
          {settings === "settings_expert_question_status" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_expert_question_status")}{" "}
              </div>
              <div>
                :
                {this.props.data.locked && this.props.data.expertQuestionStatus !== "RESOLVED"  
                  ? this.getLockedIconAndTooltip() 
                  : this.props.t("expert_question_status_" + this.props.data.expertQuestionStatus.toLowerCase())}
                &nbsp;
              </div>
            </div>
          )}
          {settings === "settings_expert_question_visibility" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_expert_question_visibility")}
              </div>
              <div>: {this.props.t(this.props.data.expertQuestionVisibility.toLowerCase().replace("public_view_only","public_view"))}&nbsp;</div>
            </div>
          )}
          {settings === "settings_expert_question_urgency" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {"settings_expert_question_urgency"}
              </div>
              <div>: {this.props.t("expert_question_urgency_" + this.props.data.urgency.toLowerCase())}&nbsp;</div>
            </div>
          )}
        </span>
      </div>
    );
  };
  secondaryInfo = (settings) => {
    if (this.props.fullscreen) {
      if (!this.props.fullscreenSettings) {
        settings = [];
        if (this.props.expertQuestionOptions) {
          for (let i = 0; i < this.props.expertQuestionOptions.length; i++) {
            settings.push({
              label: this.props.expertQuestionOptions[i],
              order: i,
            });
          }
        }
      } else {
        if (!settings) {
          settings = JSON.parse(this.props.fullscreenSettings);
        } else {
          settings = JSON.parse(settings);
        }
      }
      this.setState({ secondaryString: "" });
    } else {
      if (this.props.secondaryInfo) {
        return this.props.secondaryInfo;
      }
      if (!settings) {
        settings = "settings_discussions_date_last_post";
      }

      const { classes } = this.props;
      let info = (
        <div>
          {this.props.fullscreen && settings
            ? settings.map((setting) => {
                return this.returnSettingItem(setting);
              })
            : this.returnSettingItem(settings)}
        </div>
      );
      this.setState({ secondaryString: info });
    }
  };
  extendedInfo(settings) {
    const { classes } = this.props;
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.expertQuestionOptions.length; i++) {
        settings.push({ label: this.props.expertQuestionOptions[i], order: i });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>{this.props.t(setting.label)}</TableCell>
              {setting.label === "settings_discussions_posted_by" && (
                <TableCell>
                  <DisplayUser
                    userId={this.props.data.postedById}
                    user={this.props.data.postedBy}
                  />
                </TableCell>
              )}
              {setting.label === "settings_discussions_location" && (
                <TableCell>
                  {
                    <DisplayLocation
                      type={this.props.data.type}
                      itemId={this.props.data.itemId}
                      topicId={this.props.data.topicId}
                      title={this.props.data.targetTitle}
                    />
                  }
                </TableCell>
              )}
              {setting.label === "settings_discussions_date_created" && (
                <TableCell>
                  {moment(this.props.data.time).format("LLL")}
                </TableCell>
              )}
              {setting.label === "settings_discussions_number_posts" && (
                <TableCell>{this.props.data.numberOfEntries}</TableCell>
              )}
              {setting.label === "settings_discussions_number_views" && (
                <TableCell>
                  {this.props.data.views ? this.props.data.views : 0}
                </TableCell>
              )}
              {setting.label === "settings_discussions_date_last_post" && (
                <TableCell>
                  {moment(this.props.data.lastPostDate).format("LLL")}
                </TableCell>
              )}
              {setting.label === "settings_expert_question_status" && (
                <TableCell>
                  {this.props.data.locked && this.props.data.expertQuestionStatus !== "RESOLVED"  
                    ? this.getLockedIconAndTooltip()
                    : this.props.t("expert_question_status_" + this.props.data.expertQuestionStatus.toLowerCase())}
                </TableCell>
              )}
              {setting.label === "settings_expert_question_visibility" && (
                <TableCell>
                  {this.props.t(this.props.data.expertQuestionVisibility.toLowerCase().replace("public_view_only","public_view"))}
                </TableCell>
              )}
              {setting.label === "settings_expert_question_urgency" && (
                <TableCell>{this.props.t("expert_question_urgency_" + this.props.data.urgency.toLowerCase())}</TableCell>
              )}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString });
  }
}
const mapStateToProps = (state) => ({
  expertQuestionOptions: state.selectionOption.expertQuestionSettingsOptions,
});
export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withRouter(withTranslation()(ItemExpertQuestion))));
